import { from } from 'rxjs';
import { openLinkBankAccountFormAction } from '@banking/ui/workflows/bank-accounts/all-locations';

// State
// =============================================================================

export const INITIAL_STATE = {
  isModalOpen: false,
  merchantToken: '',
  unitToken: '',
  itFee: '',
  isLoading: true
};
export const createState = (overrides = {}) => ({
  ...INITIAL_STATE,
  ...overrides
});

// Action
// =============================================================================

export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["OpenCheckingUpsellModal"] = "OPEN_CHECKING_UPSELL_MODAL";
  ActionType["CloseCheckingUpsellModal"] = "CLOSE_CHECKING_UPSELL_MODAL";
  ActionType["GetInstantTransferFeeReceived"] = "IT_FEE_RECEIVED";
  return ActionType;
}({});
// Action Creators
// =============================================================================

export const closeCheckingUpsellModalAction = linkExternalBankAccount => ({
  type: ActionType.CloseCheckingUpsellModal,
  linkExternalBankAccount
});
export const openCheckingUpsellModalAction = (merchantToken, unitToken) => ({
  type: ActionType.OpenCheckingUpsellModal,
  merchantToken,
  unitToken
});
export const getInstantTransferFeeReceivedAction = response => ({
  type: ActionType.GetInstantTransferFeeReceived,
  response
});

// Update
// =============================================================================

function handleCloseCheckingUpsellModal(state, action) {
  const {
    linkExternalBankAccount
  } = action;
  const work = () => {
    return linkExternalBankAccount ? openLinkBankAccountFormAction(state.unitToken, state.itFee, state.merchantToken) : null;
  };
  return [{
    ...state,
    isModalOpen: false
  }, work];
}
function handleOpenCheckingUpsellModal(context, state, action) {
  const {
    merchantToken,
    unitToken
  } = action;
  const work = () => {
    if (unitToken !== state.unitToken && !state.itFee) {
      return from(context.bankingTransferApi.isEligibleForInstantDeposit(unitToken).then(getInstantTransferFeeReceivedAction, () => null));
    }
    return null;
  };
  return [{
    ...state,
    isModalOpen: true,
    merchantToken,
    unitToken
  }, work];
}
function handleGetInstantTransferFeeReceivedAction(state, action) {
  const {
    response
  } = action;
  // This is the same-day deposit fee, and _not_ instant
  // transfer deposit fee, which can be zeroed based on
  // a feature flag or reward.
  const itFee = response?.sameDayDepositBaseFee?.feeBasisPoints || response?.sameDayDepositBaseFee?.feeBasisPoints === 0 ? `${response.sameDayDepositBaseFee.feeBasisPoints / 100}%` : '';
  return [{
    ...state,
    isLoading: false,
    itFee
  }, null];
}
export const update = context => (state, action) => {
  switch (action.type) {
    case ActionType.CloseCheckingUpsellModal:
      return handleCloseCheckingUpsellModal(state, action);
    case ActionType.OpenCheckingUpsellModal:
      return handleOpenCheckingUpsellModal(context, state, action);
    case ActionType.GetInstantTransferFeeReceived:
      return handleGetInstantTransferFeeReceivedAction(state, action);
  }
};